export default {
  "content": "<path d=\"M5 19h14v-3h2v4a1 1 0 01-1 1H4a1 1 0 01-1-1v-4h2v3z\" fill=\"#7B61FF\"/><path d=\"M13 3v10.086l2.793-2.793 1.414 1.414-4.5 4.5a1 1 0 01-1.34.066l-.074-.066-4.5-4.5 1.414-1.414L11 13.086V3h2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};